import { Flex, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Namespace, TFunction } from 'react-i18next';

import { RetrieveWarehouseSchema } from '@app/models/wms';
import { DeactivatedTag } from '@components/warehouses';

import { Status } from '../../components/Status';

export const getWarehouseColumns = ({
  isProvider,
  t,
}: {
  isProvider: boolean;
  t: TFunction<Namespace<'warehouses'>>;
}): ColumnsType<RetrieveWarehouseSchema> => [
  {
    title: t('tableColumns.name'),
    dataIndex: 'name',
    key: 'name',
    render: (value: string, record) => (
      <Flex gap={8} align="center" wrap>
        <Typography.Text>{value}</Typography.Text>
        <DeactivatedTag deactivatedAt={record.deactivated_at} byCustomer={isProvider} />
      </Flex>
    ),
  },
  {
    title: t('tableColumns.is_active'),
    dataIndex: 'is_active',
    key: 'is_active',
    ellipsis: true,
    render: (value, record) => <Status status={record.is_active} />,
  },
];
